import React, { FC } from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { isSpacerElement } from 'utils/typeGuards';
import { SpacerArea } from './Spacer.styled';

const Spacer: FC<DraggableComponentProps> = ({ currentElement }) => {
  if (!isSpacerElement(currentElement)) {
    return null;
  }

  const { height } = currentElement.content;

  return <SpacerArea height={`${height}px`} />;
};

export default Spacer;
